import ExportReport from './containers/ExportReport';
import pageLayoutHoc from '../../hocs/pageLayoutHoc';
export const reportRoutes = [
    {
        path: '/reports/export',
        component: pageLayoutHoc(ExportReport, {apps: 'Reports', layoutPhase: 1}),
        key: 'ExportReport',
        apps:'maintenance'
    }
]